import { Params, useLoaderData } from "react-router-dom";
import { API_URL } from "../../../lib/config";
import { Post as PostType } from "../../../lib/post";
import { Link } from "react-router-dom";
import chevronLeft from "../../../assets/images/icons/chevron-back-outline.svg";

export async function loader({ params }: { params: Params }) {
    const id = parseInt(params.id || "");
    let post: PostType | null = null;

    if (!isNaN(id)) {
        try {
            const response = await fetch(API_URL + "/posts/" + id);
            if (response.ok) {
                post = await response.json();
            }
        } catch (error) {
            console.error(error);
        }
    }

    if (!post) {
        throw new Error("404: Post not found");
    }

    return post;
}

export default function Post() {
    const post = useLoaderData() as Awaited<ReturnType<typeof loader>>;

    return (
        <div className="flex w-11/12 max-w-5xl flex-col gap-2">
            <div className="flex flex-col gap-1 font-medium">
                <h1 className="w-full border-b border-xv-border-color px-2 py-1 text-4xl">
                    {post.title}
                </h1>
                <span className="px-2 py-1 text-sm">
                    {new Date(post.createdAt).toLocaleDateString()}
                </span>
            </div>
            <div
                className="rounded-md bg-xv-bg-2 p-4 md:p-6"
                dangerouslySetInnerHTML={{ __html: post.content || "" }}
            ></div>
            <Link className="flex gap-2 items-center hocus:brightness-90 bg-xv-bg-2 px-4 py-2 border-xv-border-color rounded-md border w-fit" to={"/blog"}>
                <img className="w-8" src={chevronLeft} alt="<" />
                <span className="leading-none">Voltar</span>
            </Link>
        </div>
    );
}
